"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaledExternalAssignmentContainerSchema = void 0;
// LoanTapeField main content (non-namespace exports)
const _imports_1 = require("../_imports");
// Zod schema for SignaledExternalAssignmentContainer
exports.SignaledExternalAssignmentContainerSchema = _imports_1.z.object({
    signaledExternalAssignmentField: _imports_1.z.string(),
    signaledExternalAssignment: _imports_1.z.string(),
});
//# sourceMappingURL=LoanTapeField.js.map